export const PBPIpt = [
  "Você se emociona facilmente.",
  "Você tem muita energia.",
  "Você faz amigos com frequência.",
  "No trabalho é uma pessoa minuciosa e detalhista.",
  "Você é original, tem ideias novas.",
  "Você lida bem com estresse.",
  "Quando está em um momento difícil, consegue encontrar um lugar de calma dentro de si.",
  "Você fica tenso com frequência.",
  "Você tende a ser quieta.",
  "Você considera a ideia de se promover em redes sociais uma tarefa difícil.",
  "Você pode ser desleixado para fazer as coisas.",
  "Você se interessa por áreas diferentes de conhecimento.",
  "Preocupações atrapalham seu bem-estar.",
  "Ao refletir sobre sua vida até agora, tem a sensação de que uma parte de si esteve presente em todos os momentos.",
  "Para fazer uma escolha, você prioriza os fatos em vez de seus sentimentos.",
  "Você gosta de atividades de movimento, como esportes e dança.",
  "É extrovertida e sociável.",
  "Você persevera até concluir as tarefas.",
  "Você considera discutir sobre teorias filosóficas abstratas uma perda de tempo.",
  "Você tem medo dos seus sentimentos.",
  "Tem o hábito de se definir como uma palavra específica (ex: “eu sou …”).",
  "Você fica nervoso facilmente.",
  "Você tende a ser preguiçoso.",
  "Você é reservado.",
  "Você tende a ser desorganizada.",
  "Você tem uma imaginação fértil.",
  "Você é temperamental e instável emocionalmente.",
  "Tem dificuldade em manter a atenção no que está acontecendo no momento.",
  "Você geralmente se orienta mais por argumentos factuais do que pelos sentimentos.",
  "Você prefere fazer atividades que gastem menos energia.",
  "Você gosta de participar de trabalho em equipe.",
  "Você gosta de rotina.",
  "Você prefere tarefas que tenham etapas concretas do que as que exigem soluções criativas.",
  "Você é emocionalmente estável, não se perturba facilmente.",
  "Você frequentemente chora em eventos emocionantes.",
  "Você prefere ambientes tranquilos e com poucos estímulos do que lugares movimentados e agitados.",
  "Você geralmente é uma pessoa tímida e inibida.",
  "Você normalmente deixa para fazer as coisas no último minuto possível.",
  "Você gosta de refletir, jogar com as ideias.",
  "Emoções causam problemas na sua vida.",
  "Ao tomar uma decisão, você foca no que é mais lógico do que em como as pessoas afetadas podem se sentir.",
  "Seus amigos descreveriam você como uma pessoa ativa.",
  "Você gostaria de um trabalho em que pudesse conhecer novas pessoas.",
  "Você cumpre e finaliza os planos que faz.",
  "Suas lembranças dolorosas te impedem de ter uma vida plena.",
];

export const PBPIen = [
  "You get emotional easily.",
  "You have a lot of energy.",
  "You make friends easily.",
  "At work, you are a meticulous and detail-oriented person.",
  "You are original and have new ideas.",
  "You handle stress well.",
  "When you are going through a difficult time, you are able to find a place of calm within yourself.",
  "You feel tense frequently.",
  "You tend to be quiet.",
  "You find the idea of promoting yourself on social media a difficult task.",
  "You can be careless when doing things.",
  "You are interested in different areas of knowledge.",
  "Worries interfere with your well-being.",
  "When reflecting on your life so far, you have the sense that a part of yourself has been present in all moments.",
  "When making a choice, you prioritize facts over your feelings.",
  "You enjoy activities involving movement, such as sports and dance.",
  "You are outgoing and sociable.",
  "You persevere until you complete tasks.",
  "You consider discussing abstract philosophical theories a waste of time.",
  "You are afraid of your feelings.",
  "You have the habit of defining yourself using a specific word (e.g., “I am …”).",
  "You get nervous easily.",
  "You tend to be lazy.",
  "You are reserved.",
  "You tend to be disorganized.",
  "You have a fertile imagination.",
  "You are temperamental and emotionally unstable.",
  "You have difficulty maintaining attention on what is happening in the present moment.",
  "You generally orient yourself more by factual arguments than by feelings.",
  "You prefer to do activities that require less energy.",
  "You enjoy participating in teamwork.",
  "You like routine.",
  "You prefer tasks with concrete steps rather than those that require creative solutions.",
  "You are emotionally stable and not easily disturbed.",
  "You often cry at emotional events.",
  "You prefer calm environments with few stimuli over busy and hectic places.",
  "You are usually shy and inhibited.",
  "You usually leave things until the very last minute.",
  "You enjoy reflecting and playing with ideas.",
  "Emotions cause problems in your life.",
  "When making a decision, you focus more on what is logical than on how the people affected might feel.",
  "Your friends would describe you as an active person.",
  "You would like a job where you could meet new people.",
  "You follow through on and complete the plans you make.",
  "Your painful memories prevent you from having a fulfilling life.",
];
